module.exports = __webpack_public_path__ + "static/media/icon-four.695a234b.webp";